/**
 * Unwraps nested { result } fields until you hit a non-object or no more "result" keys.
 */
function getResult(obj) {
    let current = obj;
    while (current &&
        typeof current === "object" &&
        Object.prototype.hasOwnProperty.call(current, "result")) {
        current = current.result;
    }
    return current;
}
// Determines HTTP method, defaults to GET or POST based on body
function getMethod(method = null, body = null) {
    const validMethods = ['GET', 'POST', 'PUT', 'PATCH', 'PULL'];
    method = (method || '').toUpperCase();
    if (!validMethods.includes(method)) {
        method = body ? 'POST' : 'GET';
    }
    return method;
}
// Gets headers, skips JSON headers when body is FormData
function getHeaders(headers = {}, method = null, body = null) {
    const result = { ...headers };
    // let browser set boundary
    if (body instanceof FormData) {
        return result;
    }
    const upper = method?.toUpperCase();
    if (['POST', 'PUT', 'PATCH'].includes(upper ?? '') &&
        !result['Content-Type']) {
        result['Content-Type'] = 'application/json';
    }
    return result;
}
// Prepares request body, serializes to JSON for non-GET requests
function getBody(body = null, method = null) {
    method = getMethod(method, body);
    if (method === 'GET') {
        return undefined;
    }
    if (body) {
        try {
            return JSON.stringify(body);
        }
        catch (err) {
            return body;
        }
    }
    return undefined;
}
// Prepares fetch variables, passes FormData intact
function getFetchVars(headers = null, method = null, body = null) {
    method = getMethod(method, body);
    headers = getHeaders(headers || {}, method, body);
    // only JSON-stringify non-FormData bodies
    if (!(body instanceof FormData)) {
        body = getBody(body, method);
    }
    return { method, headers, body };
}
/*
 * parseResult no longer needs to worry about JSON vs HTML redirect errors;
 * all 401/403 have already been handled above.
 */
async function parseResult(res) {
    // runs checkResponse first, will throw if session is expired
    res = checkResponse(res);
    if (!res.ok) {
        // for any other non-401 errors, you can still surface them
        const errorText = await res.text();
        throw new Error(errorText || res.statusText);
    }
    // now safely parse JSON
    return res.json();
}
/**
 * Intercept 401/403 and force a clean redirect to login
 * without ever showing an alert.
 */
function checkResponse(res) {
    if (res.status === 401 || res.status === 403) {
        // 1) clear out the stale token
        localStorage.removeItem("token");
        // 2) replace history so "back" doesn’t re-trigger the protected route
        window.history.replaceState({}, "", "/secure-files");
        // 3) short-circuit all further fetch logic
        throw new Error("SessionExpired");
    }
    return res;
}

export { checkResponse, getBody, getFetchVars, getHeaders, getMethod, getResult, parseResult };
//# sourceMappingURL=utils.js.map
